import React, { useState, useEffect } from 'react';
import { Textarea } from './ui/textarea';

function GrantSpiralOrb({ wisdom, enabled = true }) {
  const [showQuote, setShowQuote] = useState(true);
  const [userInput, setUserInput] = useState('');

  useEffect(() => {
    if (enabled) {
      // Fade quote to input after 3 minutes
      const timer = setTimeout(() => {
        setShowQuote(false);
      }, 180000);
      
      return () => clearTimeout(timer);
    }
  }, [enabled]);

  if (!enabled) return null;

  return (
    <div className="relative w-full max-w-3xl mx-auto mb-12" style={{ minHeight: '200px' }}>
      {/* Grant Math Spiral - Subtle Background */}
      <div 
        className="absolute inset-0 overflow-hidden"
        style={{
          backgroundImage: `url('https://customer-assets.emergentagent.com/job_nvc-workbook/artifacts/qur2gzjx_23C10E84-848E-4469-9487-21414D355AB9.png')`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          animation: 'organicPulse 25s ease-in-out infinite',
          opacity: 0.15,
          filter: 'blur(3px)',
          borderRadius: '12px'
        }}
      />

      {/* Content Box - Slightly Organic Rectangle */}
      <div 
        className={`relative p-8 transition-opacity duration-1000 ${showQuote ? 'opacity-100' : 'opacity-0 pointer-events-none'}`}
        style={{
          background: 'linear-gradient(135deg, rgba(255, 248, 240, 0.95) 0%, rgba(250, 245, 235, 0.98) 100%)',
          borderRadius: '16px',
          border: '1px solid rgba(0, 0, 0, 0.08)',
          boxShadow: '0 4px 16px rgba(0, 0, 0, 0.06)'
        }}
      >
        <p className="text-xl md:text-2xl font-serif italic text-center leading-relaxed text-gray-800" style={{ fontFamily: "'Playfair Display', Georgia, serif" }}>
          {wisdom}
        </p>
      </div>

      {/* Input Field */}
      <div 
        className={`relative transition-opacity duration-1000 ${!showQuote ? 'opacity-100' : 'opacity-0 pointer-events-none'}`}
        style={{
          background: 'linear-gradient(135deg, rgba(255, 248, 240, 0.95) 0%, rgba(250, 245, 235, 0.98) 100%)',
          borderRadius: '16px',
          border: '1px solid rgba(0, 0, 0, 0.08)',
          boxShadow: '0 4px 16px rgba(0, 0, 0, 0.06)',
          padding: '16px'
        }}
      >
        <Textarea
          placeholder="Write your thoughts, reflections, or insights here..."
          value={userInput}
          onChange={(e) => setUserInput(e.target.value)}
          className="w-full min-h-[140px] resize-none border-none bg-transparent text-gray-800"
          style={{ fontFamily: "'Playfair Display', Georgia, serif" }}
        />
      </div>

      <style>{`
        @keyframes organicPulse {
          0%, 100% { transform: scale(1) rotate(0deg); }
          50% { transform: scale(1.05) rotate(2deg); }
        }
      `}</style>
    </div>
  );
}

export default GrantSpiralOrb;
